<script>
import { escapeRegexpString } from 'element-ui/src/utils/util';
import ElOption from 'element-ui/packages/option';
export default {
  name: 'JyOption',
  extends: ElOption,
  props: {
    extLabel: String
  },
  methods: {
    queryChange(query) {
      let extLabel = this.extLabel || '';
      let reg = new RegExp(escapeRegexpString(query), 'i');
      this.visible = reg.test(this.currentLabel) || reg.test(extLabel) || this.created;
      if (!this.visible) {
        this.select.filteredOptionsCount--;
      }
    }
  }
}
</script>